export default {
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SjlHotelProductList', title: '同步产品' },
      { name: 'SjlHotelOrderList', title: '订单直连' },
      { name: 'SjlHotelApiConfigure', title: 'API配置' },
      { name: 'SjlHotelSyncRule', title: '同步规则' }
    ])
  }
}
